import { render, staticRenderFns } from "./changePic.vue?vue&type=template&id=1f5cb5bd&scoped=true&"
import script from "./changePic.vue?vue&type=script&lang=js&"
export * from "./changePic.vue?vue&type=script&lang=js&"
import style0 from "./changePic.vue?vue&type=style&index=0&id=1f5cb5bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5cb5bd",
  null
  
)

export default component.exports